import React from "react";
import { HiOutlineCheck } from "react-icons/hi2";

const TimesheetTableCheckbox = ({
  checked,
  disabled,
  onChange,
  onClick,
  className = "",
}) => {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      disabled={disabled}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(e);
        if (!disabled) onChange?.(!checked);
      }}
      className={`timesheet-table-checkbox flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded border-2 transition-colors ${
        checked
          ? "border-[#4A6BB6] bg-[#4A6BB6] shadow-sm"
          : "border-[#64748B] bg-white shadow-[inset_0_0_0_1px_#E2E8F0]"
      } ${
        disabled
          ? "cursor-not-allowed border-[#CBD5E1] bg-[#F1F5F9] opacity-50"
          : "cursor-pointer hover:border-[#4A6BB6] hover:shadow-sm"
      } ${className}`}
    >
      {checked && <HiOutlineCheck className="h-3 w-3 text-white" strokeWidth={3} />}
    </button>
  );
};

export default TimesheetTableCheckbox;
